// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__HrDlH","footer":"NavbarSimple_footer__aYEen","link":"NavbarSimple_link__RHZJC","linkIcon":"NavbarSimple_linkIcon__lXIPu"};